<modal-title
  class="modal-title-v2"
  [title]="'ProjectContacts.Add.title' | translate"
  [closeCallback]="cancel.bind(this)"
/>

<form [formGroup]="form" class="project-contacts-add-modal">
  <mat-dialog-content
    class="mb-3"
    [ngClass]="{ 'project-contacts-add-modal--min-height': contactSearchSelect?.select?.isOpen }"
  >
    <div class="mt-2">
      <ng-select
        ngSelectExtension
        #contactSearchSelect="ngSelectExtensionDir"
        [url]="
          Config.API + '/contact/search?excludeProjects=1&projectIds[]=' + projectPreviewService?.project?.id
        "
        class="w-100 new-select"
        [placeholder]="'ProjectContacts.Add.searchPlaceholder' | translate"
        [loadingText]="'Contacts.Manage.loadingContacts' | translate"
        [notFoundText]="'Contacts.Manage.notFoundContacts' | translate"
        [addTagText]="'Contacts.Manage.addContact' | translate"
        [formControlName]="'contact'"
        [bindLabel]="'fullName'"
        [responseTransform]="transformResponseToContacts.bind(this)"
        [hideSelected]="true"
        [bindValue]="'id'"
        [multiple]="false"
        [closeOnSelect]="true"
        [addTag]="onCreateContact.bind(this)"
        [tabIndex]="-1"
      >
        <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
          <contact-option-template [contact]="item"></contact-option-template>
        </ng-template>
      </ng-select>
      <span
        *ngIf="form?.get('contact')?.touched && !form?.get('contact')?.value"
        class="d-flex form-control-error-msg mt-2"
        [innerHTML]="'ProjectContacts.Add.notChosenContact' | translate"
      ></span>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <div class="d-flex justify-content-end">
      <app-button
        [disabled]="loading"
        (onClick)="cancel()"
        [config]="{
          type: ButtonTypes.NEW_SECONDARY_BLUE,
          text: 'ProjectContacts.Add.cancel' | translate,
          size: ButtonSize.LARGE
        }"
      />
      <app-button
        [class]="'ml-3'"
        [loading]="loading"
        [disabled]="loading"
        (onClick)="submit()"
        [config]="{
          type: ButtonTypes.NEW_PRIMARY_BLUE,
          text: 'ProjectContacts.Add.save' | translate,
          size: ButtonSize.LARGE,
          prependSrc: './assets/img/ic-save.svg'
        }"
      />
    </div>
  </mat-dialog-actions>
</form>
